require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./apis-and-microservices-basic-node-and-express-serve-json-on-a-specific-route.json") })
        }
      }, "path---apis-and-microservices-basic-node-and-express-serve-json-on-a-specific-route");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---apis-and-microservices-basic-node-and-express-serve-json-on-a-specific-route!./.cache/json/apis-and-microservices-basic-node-and-express-serve-json-on-a-specific-route.json
// module id = 1268
// module chunks = 231608221292675